import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { Box } from './ventblock';
import Pink from '../img/ekglongpink.png'
import Green from '../img/ekglonggreen.png'


export default function Charts() {


  return (<Box>
    <TwoRow>
      <Div>
        <Header>Paw
         <CustomInfo icon={faInfoCircle} />
        </Header>
        <Row>
          <LabelGrid>
            <One>40</One>
            <Two>20</Two>
            <Three>0</Three>
          </LabelGrid>
          <R />
          <L />
          <R />
          <L />
          <R />
          <L />
          <R />
          <L />
          <R />
          <L />
          <R />
          <L />
          <R />
          <L />
          <R />
          <L />
        </Row>
        <Imgwrap>
          <Img src={Green} />
        </Imgwrap>
      </Div>
      <Div>
        <Header>Paw</Header>
        <Row>
          <LabelGrid>
            <One>75</One>
            <Two>0</Two>
            <Three>-75</Three>
          </LabelGrid>
          <TB>
            <Top />
            <Bottom />
          </TB>
          <TB>
            <TopBlank />
            <BottomBlank />
          </TB>
          <TB>
            <Top />
            <Bottom />
          </TB>
          <TB>
            <TopBlank />
            <BottomBlank />
          </TB>
          <TB>
            <Top />
            <Bottom />
          </TB>
          <TB>
            <TopBlank />
            <BottomBlank />
          </TB>
          <TB>
            <Top />
            <Bottom />
          </TB>
          <TB>
            <TopBlank />
            <BottomBlank />
          </TB>
          <TB>
            <Top />
            <Bottom />
          </TB>
          <TB>
            <TopBlank />
            <BottomBlank />
          </TB>
          <TB>
            <Top />
            <Bottom />
          </TB>
          <TB>
            <TopBlank />
            <BottomBlank />
          </TB>
          <TB>
            <Top />
            <Bottom />
          </TB>
          <TB>
            <TopBlank />
            <BottomBlank />
          </TB>
          <TB>
            <Top />
            <Bottom />
          </TB>
          <TB>
            <TopBlank />
            <BottomBlank />
          </TB>
        </Row>
        <Row2>
          <TB>
            <TopStraight />
            <BottomBlank />
          </TB>
          <Number>2</Number>

          <TB>
            <TopStraight />
            <BottomBlank />
          </TB>
          <Number>4</Number>
          <TB>
            <TopStraight />
            <BottomBlank />
          </TB>
          <Number>6</Number>
          <TB>
            <TopStraight />
            <BottomBlank />
          </TB>
          <Number>8</Number>
          <TB>
            <TopStraight />
            <BottomBlank />
          </TB>
          <Number>10</Number>
          <TB>
            <TopStraight />
            <BottomBlank />
          </TB>
          <Number>12</Number>
          <TB>
            <TopStraight />
            <BottomBlank />
          </TB>
          <Number>14</Number>
          <TB>
            <TopStraight />
            <BottomBlank />
          </TB>
        </Row2>
        <Imgwrap2>
          <Img src={Pink} />
        </Imgwrap2>
      </Div>
    </TwoRow>

  </Box>)
}

const Imgwrap = styled.div`
  position: absolute;
  top: 50px;
    left: 33px;
    width: 92%;
  @media screen and (max-width: 823px) and (orientation: landscape) {
    top: 24px;
    left: 22px;
    width: 92%;
    }

`;
const Imgwrap2 = styled.div`
  position: absolute;
  top: 43px;
    left: 33px;
    width: 92%;
      @media screen and (max-width: 823px) and (orientation: landscape) {
    top: 24px;
    left: 25px;
    width: 92%;
    }
`;
const Img = styled.img`
  width: 100%;
`;
const CustomInfo = styled(FontAwesomeIcon)`
    color: rgba(255,255,255,0.5);

`;
const Number = styled.div`
    display: flex;
    align-items: center;
    padding: 0 5px;
     font-size: 12px;
  color: rgba(255,255,255,0.5);
}
`;
const TB = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Top = styled.div`
  border-right: 1px dashed rgba(255,255,255,0.15);
  border-bottom: 1px dashed rgba(255,255,255,0.15);
  flex-grow: 1;
`;
const Bottom = styled.div`
  border-right: 1px dashed rgba(255,255,255,0.15);
   flex-grow: 1;
`;
const TopBlank = styled.div`
  border-bottom: 1px dashed rgba(255,255,255,0.15);
  flex-grow: 1;
`;
const TopStraight = styled.div`
  border-bottom: 1px solid rgba(255,255,255,0.15);
  flex-grow: 1;
`;
const BottomBlank = styled.div`
   flex-grow: 1;
`;
const LabelGrid = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  margin: -10px 10px -10px 0;
  font-size: 12px;
  color: rgba(255,255,255,0.5);
  @media screen and (max-width: 823px) and (orientation: landscape) {
     margin: -5px 5px -5px 0;
    }
`;

const One = styled.div`
align-self: flex-start;
 @media screen and (max-width: 823px) and (orientation: landscape) {
   justify-self: flex-end;
    }
`;
const Two = styled.div`
  align-self: center;
   @media screen and (max-width: 823px) and (orientation: landscape) {
   justify-self: flex-end;
    }
`;
const Three = styled.div`
align-self: flex-end;
 @media screen and (max-width: 823px) and (orientation: landscape) {
   justify-self: flex-end;
    }

`;

const R = styled.div`
  border-top: 1px dashed rgba(255,255,255,0.15);
  border-bottom: 1px dashed rgba(255,255,255,0.15);
  border-right: 1px dashed rgba(255,255,255,0.15);
  flex-grow:1;
`;
const L = styled.div`
  border-top: 1px dashed rgba(255,255,255,0.15);
  border-bottom: 1px dashed rgba(255,255,255,0.15);
  flex-grow:1;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  margin: 10px;
  @media screen and (max-width: 823px) and (orientation: landscape) {
      margin: 5px;
    }
`;

const Row2 = styled.div`
  display: flex;
  flex-direction: row;

`;

const TwoRow = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  height: 100%;
  width: 100%;
  @media screen and (max-width: 823px) and (orientation: landscape) {
      overflow: hidden;
    }
`;

const Div = styled.div`
 display: flex;
   position: relative;
 flex-direction: column;
 :last-child {
   margin-top: 10px;
   @media screen and (max-width: 823px) and (orientation: landscape) {
      margin-top: 1px;
    }
 }
`;

const Header = styled.div`
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  @media screen and (max-width: 823px) and (orientation: landscape) {
      font-size: 13px;
      margin-bottom: 0;
    }
`;